import { render, staticRenderFns } from "./NewsCase.vue?vue&type=template&id=3d7832f6&scoped=true"
import script from "./NewsCase.vue?vue&type=script&lang=js"
export * from "./NewsCase.vue?vue&type=script&lang=js"
import style0 from "./NewsCase.vue?vue&type=style&index=0&id=3d7832f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7832f6",
  null
  
)

export default component.exports